<button (click)="onToggle($event)"
  class="menu-toggle-button group relative flex items-center px-5 py-3 rounded-xl bg-white shadow-sm border border-gray-100"
  [class.flat-style]="flatStyle"
  [ngClass]="showLabel ? 'gap-3' : 'justify-center'" [attr.aria-expanded]="isOpen" [attr.aria-controls]="controlsId">
  <!-- Icon container with enhanced animations -->
  <div class="relative w-7 h-7 flex items-center justify-center transition-transform duration-300 ease-in-out"
    [class.rotate-90]="isOpen">
    <!-- Modern menu icon with gradient -->
    <svg *ngIf="!isOpen" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
      stroke="currentColor" class="menu-icon w-6 h-6 text-gray-700 drop-shadow-sm">
      <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
    </svg>

    <!-- X icon when open with rotation animation -->
    <svg *ngIf="isOpen" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
      stroke="currentColor" class="menu-icon w-6 h-6 text-gray-700">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </div>

  <!-- Enhanced text with gradient and better typography -->
  <span *ngIf="showLabel" class="relative text-sm font-medium text-gray-800">
    {{ 'Wszystkie kategorie' | translate }}
  </span>

</button>